import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import {OrderComponent} from "./order/order.component";
import {ContactOrderComponent} from "./contact-order/contact-order.component";
import { PersonalInfoComponent } from './personal-info/personal-info.component';
import { OrdersComponent } from './orders/orders.component';
import { OrderProgressComponent } from './order/order-progress/order-progress.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CouponsComponent } from './coupons/coupons.component';

const routes: Routes = [
  { path: 'order/:orderId', component: OrderComponent},
  { path: 'order/:orderId/re-order', component: OrderComponent},
  { path: 'order/:orderId/contact', component: OrderComponent},
  { path: 'reset-password', component: ResetPasswordComponent},
  { path: '**', component: AccountComponent}
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatTableModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  declarations: [AccountComponent, OrderComponent, ContactOrderComponent, PersonalInfoComponent, OrdersComponent, OrderProgressComponent, ResetPasswordComponent, CouponsComponent]
})
export class AccountModule { }

